<div class="closeCross">
  <span mat-dialog-title>{{ ('participant') | translate }}</span>
  <mat-icon (click)="closeDialog($event)" class="cross">close</mat-icon>
  <saf-bug-report-button></saf-bug-report-button>
</div>

<div class="container" fxLayout="column" fxLayoutGap="16px" fxLayoutGap.xs="8px">
  <section class="header" fxLayout="row" fxLayoutGap="16px" fxLayoutGap.xs="8px">
    @if (acceptMember && tuitionStatus !== 1 ) {
      <button class="schooling" mat-raised-button color="primary" (click)="openDialog()">
        <mat-icon>add</mat-icon>
        <span>{{ 'addParticipant' | translate }}</span>
      </button>
    }

    <saf-filter-panel [placeholder]="('enterSearchTermName' | translate)" (filterChange)="applyDrawerFilters($event)"></saf-filter-panel>
  </section>
  <mat-card appearance="outlined" class="content">

    <div class="dialog-table-container" [fxShow]="dataSource.data.length">
      <table mat-table [dataSource]="dataSource" id="table" class="table" matSort matSortActive="employeeNumber" matSortDirection="asc" [trackBy]="trackById" [safResizableColumns]="null">

        <ng-container matColumnDef="select">

          <th mat-header-cell *matHeaderCellDef>
            <mat-slide-toggle  (change)="toggleAll($event)"
              [checked]="isAllSelected()">
            </mat-slide-toggle>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-slide-toggle
              [checked]="checked(row)"
              (change)="selectParticipant(row, $event)">
            </mat-slide-toggle>
          </td>
        </ng-container>

        <ng-container matColumnDef="employeeNumber">
          <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header="employeeNumber"
          matTooltip="{{ 'personalNumber' | translate }}">{{ 'personalNumberShort' | translate }}</th>
          <td mat-cell *matCellDef="let data">
            <span class="{{ checkIfStandard(data) ? (data.employee.employeeNumber ? '' : 'saf-chip') : (data.externalEmployee.employeeNumber ? '' : 'saf-chip') }}"
              [matTooltip]="checkIfStandard(data) ? (data.employee.employeeNumber? data.employee.employeeNumber : '-') : (data.externalEmployee.employeeNumber? data.externalEmployee.employeeNumber : '-')">
              {{ checkIfStandard(data) ? (data.employee.employeeNumber ? data.employee.employeeNumber : '-') : (data.externalEmployee.employeeNumber ? data.externalEmployee.employeeNumber : '-') }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header="employeeLastName">{{ 'name' | translate }}</th>
          <td mat-cell *matCellDef="let data">
            <span
            [safEmployeeQuickView]="checkIfStandard(data) ? data.employee.id : null">{{ checkIfStandard(data) ?  data.employee.name : ''}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header="employeeName">{{ 'firstName' | translate }}</th>
          <td mat-cell *matCellDef="let data">
            <span
            [safEmployeeQuickView]="checkIfStandard(data) ? data.employee.id : null">{{ checkIfStandard(data) ?  data.employee.firstName : ''}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header="status">{{ 'status' | translate }}</th>
          <td mat-cell *matCellDef="let data">
            @switch (data.participant.status) {
              @case (0) {
                <div class="status-color grey" matTooltip="{{ 'request' | translate }}"></div>
              }
              @case (1) {
                <div class="status-color yellow" matTooltip="{{ 'accepted' | translate }}"></div>
              }
              @case (2) {
                <div class="status-color green" matTooltip="{{ 'done' | translate }}"></div>
              }
              @case (3) {
                <div class="status-color red" matTooltip="{{ 'failed' | translate }}"></div>
              }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef>{{ 'options' | translate }}</th>
          <td mat-cell *matCellDef="let data">
            <button mat-icon-button (click)="openDeleteDialog($event, data.participant)"
              matTooltip="{{tuitionStatus === 1 ? ('notDeletable' | translate) : ('delete' | translate)}}">
              <mat-icon class="{{tuitionStatus === 1 ? 'disabledIcon' : 'deleteIcon'}}">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr mat-row class="selectable" *matRowDef="let row; columns: tableColumns;"></tr>
      </table>
      <mat-paginator class="mat-paginator-sticky" [pageSize]="checkPageSize()" [pageSizeOptions]="pageSizeOptions"
      [length]="totalCount" [showFirstLastButtons]="true" (page)="pageChange($event)"></mat-paginator>
    </div>
    @if (!dataSource.data.length && !loading) {
      <saf-empty-message (reloadClicked)="reloadTable()"></saf-empty-message>
    }


  </mat-card>
  <div mat-dialog-actions align="end">
    <button mat-raised-button class="administration deleteButtonHover" color="primary"
      (click)="closeDialog($event)">{{ 'cancel' | translate }}
    </button>
    <button mat-raised-button class="administration saveButtonHover" (click)="submit()"
      color="primary">{{ 'save' | translate }}
    </button>
  </div>
</div>
